"use client"

import styled from "@emotion/styled"
import { GetPageQuery } from "apollo"
import { ScrollingProvider } from "contexts/ScrollingProvider"
import { getParentsArray } from "lib/utils"
import { CustomBreadcrumbs } from "ui"
import { HomeIcon } from "ui/icons"
import { BlockRenderer } from "utils"
import { findProperty } from "utils/findProperty"
import AboutSection from "./AboutSection"
import Activity from "./Activity"
import BaseTitle from "./BaseTitle"
import HistoryPaz from "./History"
import Persons from "./Persons"

const StyledBreadCrumbsContainer = styled.div`
  margin-left: 28px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-left: 150px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    margin-left: 220px;
  }
`

function AboutUs({ data, locale }: { data: GetPageQuery; locale?: string }) {
  const components = {
    activitiesAreas: Activity,
    historySlider: HistoryPaz,
    teamContainer: Persons,
    baseBlock: BaseTitle,
    aboutinnerBoxs: AboutSection,
  }

  const parents = getParentsArray(data.page, 3)

  return (
    <>
      <StyledBreadCrumbsContainer>

        <CustomBreadcrumbs
          current={parents[parents.length - 1]}
          parents={[
            { title: <HomeIcon />, url: "/" },
            ...parents.slice(0, -1),
          ]}
          locale={locale}
        />

      </StyledBreadCrumbsContainer>
      <ScrollingProvider>
        {findProperty(data, "blocks")?.blocks?.map(
          // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
          (block: any, index: number) => {
            const sideMenuTitle = block.properties.find(
              (prop: any) => prop.propertyName === "sideMenuTitle",
            )?.propertyValue?.value
            return (
              <section key={index} id={sideMenuTitle || index.toString()}>
                <BlockRenderer
                  key={index}
                  props={{ locale }}
                  blockType={block.blockType}
                  blockData={block}
                  components={components}
                ></BlockRenderer>
              </section>
            )
          },
        )}
      </ScrollingProvider>
    </>
  )
}

export default AboutUs
